import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { auth } from "../firebase/firebaseConfig";
import edit from "../assets/Edit.png"
import cross from "../assets/delete.png"
import { CONT, EditIcon, TAG, UserData, UserImg } from "../styles/globalStyles";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import useForm from '../hooks/useForm';
import { listAsync, updatePhoto } from "../redux/actions/infoAction";
import { imgUpload } from "../helpers/imgUpload";
import axios from 'axios'
import { tokenProvider } from "../helpers/tokenProvider";
import { logoutUserAsync } from "../redux/actions/loginAction";

export const User = ({ userID }) => {
    const dispatch = useDispatch()
    const { listaInfo } = useSelector(store => store.info)
    const userData = listaInfo[0]
    const [profile, setProfile] = useState(null);
    const [show, setShow] = useState(false);
    const [token, setToken] = useState();
    const [background, setBackground] = useState({});
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleImage = (e) => {
        const file = e.target.files[0];
        imgUpload(file)
            .then((resp) => {
                dispatch(updatePhoto(resp, userID))
            })
            .catch((error) => {
                console.warn(error);
            });
    };

    const [formValue, handleChange, reset] = useForm(
        {
            livingCountry: '',
            countryOfBirth: '',
            address: '',
            fathersCountryOfBirth: '',
            mothersCountryOfBirth: ''
        }
    )

    const handleSubmit = async (e) => {
        e.preventDefault()
        const config = {
            headers: { Authorization: `Bearer ${token}` }
        };
        const body = {
            livingCountryId: 24,
            countryOfBirthId: 25,
            address: formValue.address,
            fathersCountryOfBirthId: 26,
            mothersCountryOfBirthId: 27,
        }
        await axios.post(
            process.env.REACT_APP_BACKEND_URL + "api/profile_my_background",
            body,
            config
        )
        reset()
        handleClose()
    }

    const getBackground = async () => {
        const config = {
            headers: { Authorization: `Bearer ${token}` }
        };
        await axios.get(
            process.env.REACT_APP_BACKEND_URL + "api/profile_my_background",
            config
        ).then((res) => {
            setBackground(res.data)
        }
        ).catch(async ({ response }) => {
            if (response.status === 401) {
                await axios.post(
                    process.env.REACT_APP_BACKEND_URL + "api/logout",
                    config
                )
                dispatch(logoutUserAsync())
            } else if (response.status === 412) {
                tokenProvider()
                    .then(async (res) => {
                        const config = {
                            headers: { Authorization: `Bearer ${res}` }
                        };
                        await axios.get(
                            process.env.REACT_APP_BACKEND_URL + "api/profile_my_background",
                            config
                        ).then((resp) => {
                            setBackground(resp.data)
                        })
                    })
            }
        }
        )
    }

    useEffect(() => {
        dispatch(listAsync())
        tokenProvider()
            .then((res) => {
                setToken(res)
            })
        const user = auth.currentUser;
        if (user) {
            setProfile(user);
        }
    }, [dispatch]);

    return (
        <>
            <div className='d-flex px-5 justify-content-between align-items-center' style={{ paddingTop: "111px" }}>
                <div className="d-flex mx-auto">
                    <UserImg src={userData?.profileImg} alt={profile?.displayName} />
                    <label for="file-input">
                        <EditIcon src={edit} alt="" />
                    </label>
                    <input
                        id="file-input"
                        type="file" accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff|image/*"
                        onChange={handleImage}
                        style={{ display: "none" }}
                    />
                </div>
                <div>
                    <button onClick={getBackground}>traer datos</button>
                    <div className="d-flex justify-content-between align-items-center">
                        <h2>Tu Información</h2>
                        <img src={edit} alt="" onClick={handleShow} style={{ cursor: "pointer" }} />
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-4 gap-3">
                        <h5>País de residencia</h5>
                        <UserData>
                            <TAG><h6>{background.livingCountryId}</h6></TAG>
                        </UserData>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-4 gap-3">
                        <h5>País de nacimiento</h5>
                        <UserData>
                            <TAG><h6>{background.countryOfBirthId}</h6></TAG>
                        </UserData>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-4 gap-3">
                        <h5>Dirección</h5>
                        <UserData>
                            <TAG><h6>{background.address}</h6></TAG>
                        </UserData>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-4 gap-3">
                        <h5>País de nacimiento del padre</h5>
                        <UserData>
                            <TAG><h6>{background.fathersCountryOfBirthId}</h6></TAG>
                        </UserData>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-4 gap-3">
                        <h5>País de nacimiento de la madre</h5>
                        <UserData>
                            <TAG><h6>{background.mothersCountryOfBirthId}</h6></TAG>
                        </UserData>
                    </div>
                </div>
            </div>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Actualiza tu Información</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3">
                            <Form.Label>País de residencia</Form.Label>
                            <Form.Control name="livingCountry" type="text" value={formValue.livingCountry} onChange={handleChange} />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>País de nacimiento</Form.Label>
                            <Form.Control name="countryOfBirth" type="text" value={formValue.countryOfBirth} onChange={handleChange} />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Dirección</Form.Label>
                            <Form.Control name="address" type="text" value={formValue.address} onChange={handleChange} />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>País de nacimiento del padre</Form.Label>
                            <Form.Control name="fathersCountryOfBirth" type="text" value={formValue.fathersCountryOfBirth} onChange={handleChange} />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>País de nacimiento de la madre</Form.Label>
                            <Form.Control name="mothersCountryOfBirth" type="text" value={formValue.mothersCountryOfBirth} onChange={handleChange} />
                        </Form.Group>
                        <Button variant="success" className="d-flex mx-auto mt-3" type="submit">Guardar Cambios</Button>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    )
}